export const operatorId = "2d9762bfa3f2fdd7e530cd05e3e3fc49"; // 操作者主键
export const source = "szitrus 官网转入" // 来源